import React from "react";
//
import {
    makeStyles,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: theme.spacing(1),
    },
}));

export default function Warning(props) {
    const { open, onClose, title, children, closeLabel } = props;
    const classes = useStyles();

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            PaperProps={{
                className: classes.dialog,
            }}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={onClose}>
                    {closeLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

Warning.defaultProps = {
    title: "Warning",
    closeLabel: "CLOSE",
};
